import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Home from "./pages/Home";
import Nike from "./pages/Nike";
import Adidas from "./pages/Adidas";
import Macys from "./pages/Macys";
import Ulta from "./pages/Ulta";
import VineyardVines from "./pages/VineyardVines";
import Zara from "./pages/Zara";
import Lacoste from "./pages/Lacoste";
// …

export default function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nike" element={<Nike />} />
        <Route path="/adidas" element={<Adidas />} />
        <Route path="/macys" element={<Macys />} />
        <Route path="/ulta" element={<Ulta />} />
        <Route path="/vineyardvines" element={<VineyardVines />} />
        <Route path="/zara" element={<Zara />} />
        <Route path="/lacoste" element={<Lacoste />} />
      </Routes>
    </>
  );
}
